import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { paymentService } from 'services/PaymentService';
import ResultItem from './ResultItem';

const styles = require('./tableCep.css');

interface IState extends IStateBase {
  model: any;
  open: boolean;
}

export default class TableCep extends BaseComponent<IState>{

  constructor(props: any) {
    super(props);
    this.state = { model: null, open: false };
  }

  choosePostalCode = (data: any) => {
    const addressData = {
      postalCode: data.cep,
      street: data.logradouro,
      district: data.bairro,
      complement: data.complemento,
      province: data.uf,
      city: data.localidade,
      country: data.country
    };

    paymentService.setAddressData(addressData);
    this.props.handleClose();
  }

  render() {
    return (
      <div className={styles.component}>
        <h6 className='chk-tableCEP__title theme-label'>Selecione uma opção</h6>
        <div className='chk-tableCEP__addressList'>
          {this.props.data.map((data: any, key: any) => (
            <ResultItem key={key} data={data} onChoose={this.choosePostalCode} />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAddressForm/Br/SearchCEP/TableCep/index.tsx